import { authorizedGet } from '..'

export type GetSignedSubtitlesProps = {
  id: string
}

export type GetSignedSubtitlesResults = {
  results: {
    lang: string
    label: string
    url: string
    spreadsheetLink?: string
  }[]
}

export const getSignedSubtitles = async ({
  id,
}: GetSignedSubtitlesProps): Promise<GetSignedSubtitlesResults> => {
  try {
    const response = await authorizedGet({
      endpoint: `translation/${id}`,
    })
    return (await response.json()) as GetSignedSubtitlesResults
  } catch (e) {
    throw e
  }
}
